// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCd3suScJPOyPEGCwFXitZjon939gBL_8o",
    authDomain: "bkhydra-7fad2.firebaseapp.com",
    databaseURL: "https://bkhydra-7fad2.firebaseio.com",
    projectId: "bkhydra-7fad2",
    storageBucket: "bkhydra-7fad2.appspot.com",
    messagingSenderId: "1065761510890",
    appId: "1:1065761510890:web:2d0e313a26bf4bf61b4e93",
    measurementId: "G-1Q517S7BPY"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
